import { render, staticRenderFns } from "./LongValueBox.vue?vue&type=template&id=79633968&scoped=true"
import script from "./LongValueBox.vue?vue&type=script&lang=js"
export * from "./LongValueBox.vue?vue&type=script&lang=js"
import style0 from "./LongValueBox.vue?vue&type=style&index=0&id=79633968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79633968",
  null
  
)

export default component.exports